import { NAV_TAB_NUMBERS } from './app-data.constants';

export const ApiBaseRoute = 'api';

export class API_ENDPOINTS {
  static readonly authentication = {
    signIn: '/SignIn'
  } as const;

  static readonly configuration = {
    default: 'FormConfiguration/GetConfiguration'
  } as const;

  static readonly address = {
    search: 'Address/Search',
    lga: 'Address/Lga'
  } as const;

  static readonly document = {
    upload: 'Document/Upload',
    download: 'Document/Download',
    flagForRemoval: 'Document/FlagForRemoval',
    remove: 'Document/Remove'
  } as const;

  static readonly networkConnectivity = {
    ping: 'NetworkConnectivity/Ping'
  } as const;

  static readonly userAuthentication = {
    getLoggedInUser: 'UserAuthentication/GetLoggedInUser'
  } as const;

  static readonly pbi = {
    embedInfo: '/PowerBI/EmbedInfo'
  } as const;

  static readonly local = {
    getSyncEntities: 'Local/GetSyncEntities'
  } as const;

  static readonly dashboard = {
    getMaatAuditPlans: 'Dashboard/GetMaatAuditPlans',
    getMaatJobs: 'Dashboard/GetMaatJobs',
    getMaatJobItems: 'Dashboard/GetMaatJobItems',
    getMaatJobItemsByAuditPlan: 'Dashboard/GetMaatJobItemsByAuditPlan',
    getMaatNcqs: 'Dashboard/GetMaatNcqs',
    getMaatNcqsByJob: 'Dashboard/GetMaatNcqsByJob',
    getMaatNcqsByAuditPlan: 'Dashboard/GetMaatNcqsByAuditPlan',
    getMaatPropertyHistoryByJob: 'Dashboard/GetMaatPropertyHistoryByJob',
    getMaatUsers: 'Dashboard/GetMaatUsers',
    getMaatSorDescriptions: 'Dashboard/GetMaatSorDescriptions',
    getBulkMaatJobs: 'Dashboard/GetBulkMaatJobs',
    getBulkMaatJobItems: 'Dashboard/GetBulkMaatJobItems',
    getBulkMaatJobItemsByAuditPlan: `Dashboard/GetBulkMaatJobItemsByAuditPlan?navTabIndex=${NAV_TAB_NUMBERS.maatJobList.maatJobItems}`,
    getBulkMaatNcqs: 'Dashboard/GetBulkMaatNcqs',
    getBulkMaatNcqsByJob: `Dashboard/GetBulkMaatNcqsByJob?navTabIndex=${NAV_TAB_NUMBERS.maatJobItemList.maatNcqs}`,
    getBulkMaatNcqsByAuditPlan: `Dashboard/GetBulkMaatNcqsByAuditPlan?navTabIndex=${NAV_TAB_NUMBERS.maatJobList.maatNcqs}`,
    getBulkMaatPropertyHistoryByJob: `Dashboard/GetBulkMaatPropertyHistoryByJob?navTabIndex=${NAV_TAB_NUMBERS.maatJobItemList.maatPropertyHistories}`,
    getOrganisations: 'Dashboard/GetOrganisations',
    getTeams: 'Dashboard/GetTeams',
    getUsers: 'Dashboard/GetUsers',
    getInspections: 'Dashboard/GetInspections',
    getNotifications: 'Dashboard/GetNotifications',
    getInspectionHistory: 'Dashboard/GetInspectionHistory',
    getReports: 'Dashboard/GetReports',
    getBatches: 'Dashboard/GetBatches',
    exportReports: 'Dashboard/ExportReports'
  } as const;

  static readonly maatAuditPlan = {
    getConfigAndResponse: 'MaatAuditPlan/GetConfigAndResponse',
    getBulkConfigsAndResponses: 'MaatAuditPlan/GetBulkConfigsAndResponses',
    save: 'MaatAuditPlan/Save',
    exportToDataTables: 'MaatAuditPlan/ExportToDataTables',
    exportSummaryReport: 'MaatAuditPlan/ExportSummaryReport'
  } as const;

  static readonly maatJob = {
    getConfigAndResponse: 'MaatJob/GetConfigAndResponse',
    getBulkConfigsAndResponses: 'MaatJob/GetBulkConfigsAndResponses',
    save: 'MaatJob/Save',
    setInspectionDate: 'MaatJob/SetInspectionDate'
  } as const;

  static readonly maatJobItem = {
    getConfigAndResponse: 'MaatJobItem/GetConfigAndResponse',
    getBulkConfigsAndResponses: 'MaatJobItem/GetBulkConfigsAndResponses',
  } as const;

  static readonly maatNcq = {
    getConfigAndResponse: 'MaatNcq/GetConfigAndResponse',
    getConfigWithEmptyResponse: 'MaatNcq/GetConfigWithEmptyResponse',
    getBulkConfigsAndResponses: 'MaatNcq/GetBulkConfigsAndResponses',    
    save: 'MaatNcq/Save',
    bulkIssueNcqs: 'MaatNcq/BulkIssueNcqs',
    bulkReIssueNcqs: 'MaatNcq/BulkReIssueNcqs'
  } as const;

  static readonly maatUser = {
    getConfigAndResponse: 'MaatUser/GetConfigAndResponse',
    save: 'MaatUser/Save'
  } as const;

  static readonly maatSorDescription = {
    getConfigAndResponse: 'MaatSorDescription/GetConfigAndResponse',
    save: 'MaatSorDescription/Save',
    delete: 'MaatSorDescription/Delete'
  } as const;

  static readonly organisation = {
    getConfigAndResponse: 'Organisation/GetConfigAndResponse',
    getConfigWithEmptyResponse: 'Organisation/GetConfigWithEmptyResponse',
    save: 'Organisation/Save'
  } as const;

  static readonly team = {
    getConfigAndResponse: 'Team/GetConfigAndResponse',
    getConfigWithEmptyResponse: 'Team/GetConfigWithEmptyResponse',
    save: 'Team/Save'
  } as const;

  static readonly user = {
    getConfigAndResponse: 'User/GetConfigAndResponse',
    getConfigWithEmptyResponse: 'User/GetConfigWithEmptyResponse',
    save: 'User/Save'
  } as const;

  static readonly inspectionList = {
    saveAppointment: 'Inspection/SaveAppointment',
    saveAppointmentDateBulk: 'Inspection/BulkSubmitInspectionAppointmentDate',
    downloadAppointmentLetter: 'Inspection/DownloadAppointmentLetter',
    generateAppointmentLetterBulk: 'Inspection/BulkGenerateAppointmentLetters',
    getInspectionWithNoAccess: 'Inspection/GetInspectionWithNoAccess',
    acceptInspection: 'Inspection/AcceptInspection',
    rejectInspection: 'Inspection/RejectInspection',
    rejectInspectionByQA: 'Inspection/RejectInspectionByQA',
    reviewInspectionByQA: 'Inspection/ReviewInspectionByQA',
    assignInspectionBulk: 'Inspection/BulkSubmitInspectionAssignee',
    unassignInspectionBulk: 'Inspection/BulkUnAssignInspection',
    downloadAppointmentLetterBulk: 'Inspection/DownloadAppointmentLetters',
    save: 'Inspection/Save',
    syncCompletedInspections: 'Inspection/SyncCompletedInspections',
    exportInspections:'Inspection/ExportInspections',
    fullExportInspections: 'Inspection/FullExportInspections',
    getConfigForBatch: 'Inspection/GetConfigForBatch',
  } as const;

  static readonly inspection = {
    getConfigAndResponse: 'Inspection/GetConfigAndResponse',
    getBulkConfigsAndResponses: 'Inspection/GetBulkConfigsAndResponses',
    getBulkNoAccessResponses: 'Inspection/GetBulkNoAccessResponses',
    save: 'Inspection/Save',
    saveManagerComments: 'Inspection/SaveManagerComments',
    saveDepartmentComments: 'Inspection/SaveDepartmentComments',
    acceptInspection: 'Inspection/AcceptInspection',
    acceptInspectionByQA: 'Inspection/AcceptInspectionByQA',
    rejectInspection: 'Inspection/RejectInspection',
    rejectInspectionByQA: 'Inspection/RejectInspectionByQA'
  } as const;

  static readonly inspectionCalendar = {
    getConfigAndResponse: 'InspectionCalendar/GetConfigAndResponse',
    saveAppointment: 'Inspection/SaveAppointment',
    getInspectionCalendarEvents: 'InspectionCalendar/GetInspectionCalendarEvents'
  } as const;

  static readonly licence = {
    fullCalendar: 'Licence/FullCalendar'
  } as const;
  
  static readonly batch = {
    submitBatch: 'Batch/SubmitBatch'
  } as const;
};
